import { Grid, MenuItem, TextField } from "@material-ui/core";
import { useEffect } from "react";
import useValidations from "../../../hooks/useValidations";
import { lang } from "../../../i18nLang";
import ColumnField from "../ColumnField";
import { ColumnControl, RedText, Title } from "./styles";

interface TabColumnProps {
  /** Objeto com as colunas referentes as propriedades obrigatórias. */
  values: { codeWBS: string; measure: string; measureBy: string };
  /** Função chamada ao alterar o valor de uma ColumnField. */
  onChange: (name: string, value: string) => void;
  /** Função chamada ao alterar o objeto de erros dos campos. */
  onChangeErrors?: Function;
  /** Objeto com as validações para os campos de coluna */
  validationColumn: {};
}

/** Formulário para definir as propriedades obrigatórias para importação da medição.
 * @category Components
 */
const TabMeasurementColumns = (props: TabColumnProps) => {
  const { validated, validateFields } = useValidations({
    codeWBS: props.validationColumn,
    measure: props.validationColumn,
    measureBy: "required",
  });

  useEffect(() => {
    const hasErrors = !validateFields(props.values, true);
    if (props.onChangeErrors) {
      props.onChangeErrors(hasErrors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeColumn = (name: string, value: string) => {
    value = value ? value.toUpperCase() : value;
    props.onChange(name, value);
  };

  const handleChangeMeasureBy = (ev) => {
    const { name, value } = ev.target;
    props.onChange(name, value);
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    const hasErrors = !validateFields({ [name]: value });
    if (props.onChangeErrors) {
      props.onChangeErrors(hasErrors);
    }
  };

  return (
    <>
      <Title>{lang(`importation.modeFile.subtitle3`)}</Title>
      <ColumnControl container justifyContent="center">
        <Grid container item xs={6} md={5} alignItems="center">
          {lang(`fields.codeWBS`)}
          <RedText>*</RedText>
        </Grid>
        <Grid container item xs={6} md={5} alignItems="center">
          <ColumnField
            name={"codeWBS"}
            value={props.values.codeWBS}
            disabled={false}
            onChange={handleChangeColumn}
            inputProps={{
              onBlur: handleBlur,
              error: !validated ? false : !validated.codeWBS.valid,
              helperText: validated.codeWBS.text,
            }}
          />
        </Grid>
      </ColumnControl>
      <ColumnControl container justifyContent="center">
        <Grid container item xs={6} md={5} alignItems="flex-start">
          <TextField
            name="measureBy"
            label={`${lang("importation.measurement.measureBy")}*`}
            value={props.values.measureBy}
            select
            fullWidth
            style={{ paddingRight: "1rem" }}
            onChange={handleChangeMeasureBy}
            onBlur={handleBlur}
            error={!validated ? false : !validated.measureBy.valid}
            helperText={validated.measureBy.text}
          >
            <MenuItem value={"quantity"}>{lang("fields.quantity")}</MenuItem>
            <MenuItem value={"percentage"}>
              {lang("fields.percentage")}
            </MenuItem>
            <MenuItem value={"total"}>{lang("fields.total")}</MenuItem>
          </TextField>
        </Grid>
        <Grid container item xs={6} md={5} alignItems="flex-start">
          <ColumnField
            name={"measure"}
            value={props.values.measure}
            disabled={false}
            onChange={handleChangeColumn}
            inputProps={{
              onBlur: handleBlur,
              error: !validated ? false : !validated.measure.valid,
              helperText: validated.measure.text,
            }}
          />
        </Grid>
      </ColumnControl>
    </>
  );
};

export default TabMeasurementColumns;
